
import { useMemo } from "react"
import { descompressResponse } from 'utils/decompress'
import axios from 'axios'

const useJobApi = (idToken) => {
  const instance = useMemo(() => {
    return axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': idToken + '.' + btoa(JSON.stringify({ "id": process.env.REACT_APP_ID }))
      }
    })
  }, [idToken])

  return {
    getJobsFromApi: () => new Promise((resolve, reject) => {
      instance.post('/service/get-jobs')
        .then((response) => {
          const responseData = response.data || response
          const data = descompressResponse(responseData)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    }),

    uploadJob: async (job, jobDetails, jobStoppages, endUsers) => {
      try {
        const response = await instance.post('/service/uploadJob', { job, jobDetails, jobStoppages, endUsers }).catch(error => {
          return { error: error.response.data.errorMessage }
        })

        if (response.status === 200) {
          const responseData = response.data || response
          const data = descompressResponse(responseData)
          return { data }
        }

        return { error: "jobApi.uploadJob failed." }
      } catch (error) {
        return { error: error.message || "jobApi.uploadJob failed." }
      }
    },

    getJob: (endUsers) => new Promise((resolve, reject) => {
      // console.debug(process.env.REACT_APP_API_URL)
      instance.post('/service/uploadJob', { getJobs: true, endUsers })
        .then(response => {
          if (response.status === 200) {
            const responseData = response.data || response
            const data = descompressResponse(responseData)
            resolve(data)
          }
          else {
            reject(new Error('Couldn\'t retrieve data'))
          }
        })
        .catch(error => {
          reject(error)
        })
    }),

    getJobDataFromApi: (jobId) => new Promise((resolve, reject) => {
      instance.post('/service/get-job-info', {
        jobId: jobId
      })
        .then((response) => {
          const responseData = response.data || response
          const data = descompressResponse(responseData)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    }),

    deleteJob: async (jobId) => {
      // eslint-disable-next-line no-unused-vars
      const { status, ...rest } = await instance.post('/service/deleteJob', { jobId }).catch(error => {
        console.log("jobApi.deleteJob error", error)
        return { error: JSON.stringify(error) }
      })

      // JOB API RETURNS OK FOR ANYTHING

      if (status === 200) return true
      return { error: "Internal Server Error" }
    },

    getDocumentsFromApi: (jobId, source) => new Promise((resolve, reject) => {
      instance.post('/document-management/manage-job-documents', {
        list: {
          jobId: jobId,
          source
        }
      })
        .then((response) => {
          const responseData = response.data || response
          const data = descompressResponse(responseData)

          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    }),

    uploadFileToApi: (file, source) => new Promise((resolve, reject) => {
      instance.post('/document-management/manage-job-documents', {
        upload: { ...file, source }
      })
        .then((response) => {
          const responseData = response.data || response
          const data = descompressResponse(responseData)

          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    }),

    getFileFromApi: (id) => new Promise((resolve, reject) => {
      instance.post('/document-management/manage-job-documents', {
        getFile: {
          id: id
        }
      })
        .then((response) => {
          const responseData = response.data || response
          const data = descompressResponse(responseData)

          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    }),

    deleteFileToApi: (id, source) => new Promise((resolve, reject) => {
      instance.post('/document-management/manage-job-documents', {
        delete: {
          id: id,
          source
        }
      })
        .then((response) => {
          const responseData = response.data || response
          const data = descompressResponse(responseData)

          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default useJobApi